import { InputText } from "primereact/inputtext";
import React, { useRef, useState } from "react";
import { T } from "services/lang/LanguageService";

type SearchInputProps = {
  currentValue: string;
  onChange: (value: string) => void;
};

const SearchDatasetsInput = ({ currentValue, onChange }: SearchInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [localValue, setLocalValue] = useState<string>(currentValue);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setLocalValue(value);
    onChange(value);
  };

  return (
    <div style={{ position: "relative" }}>
      <i
        className="pi pi-search"
        style={{ position: "absolute", top: "11px", left: "5px", fontSize: "1.4em" }}
      />
      {localValue && (
        <i
          className="pi pi-times"
          style={{
            cursor: "pointer",
            position: "absolute",
            top: "11px",
            right: "5px",
            fontSize: "1.4em",
          }}
          onClick={() => {
            setLocalValue("");
            onChange("");
          }}
        />
      )}
      <InputText
        ref={inputRef}
        type="text"
        value={localValue}
        onChange={handleInputChange}
        placeholder={T("action.search")}
        style={{ width: "100%", paddingLeft: "2.2rem" }}
      />
    </div>
  );
};

export default SearchDatasetsInput;
